<template>
  <div class="c-page-banner c-page-banner--border-left c-page-banner--center" v-if="image">
    <div class="c-page-banner__content o-cover" :style="{ 'background-image':'url(' + image.url + ')'}">
      <div class="o-box-off">
        <h3 class="c-page-banner__heading u-h2">Support the Taiko Trust</h3>
        <p class="c-page-banner__subheading u-h5">Help us continue to carry out innovative conservation projects protecting endangered species on the Chatham Islands.</p>
        <router-link class="c-btn c-btn--primary" :to="{ name: 'donate' }">Donate now</router-link>
      </div>
      <div class="c-page-banner__credit u-st1 u-mt+ u-mt0@tablet" v-if="image.credit">&copy; {{ image.credit }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Banner',
  data () {
    return {
      image: null
    }
  },
  mounted () {
    axios
      .get('/api/bannerImage.json')
      .then(response => (this.image = response.data))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Banner.vue